import React, { ReactElement } from 'react';

const Blog: React.FC = (): ReactElement => {
  return (
    <div className="text-dark w-full flex flex-col justify-center items-center">
      <div className="w-full h-full overflow-hidden flex justify-center items-center">
        <img
          src="static/resources/Blog.jpg"
          className=" min-w-[1000px] w-full min-h-[200px]"
          alt="Description"
        />
        <div className="px-8 sm:p-0 text-light text-lg md:text-xl lg:text-2xl absolute max-w-xl flex flex-col justify-center items-center">
          <p className="text-2xl md:text-3xl lg:text-4xl">Blog</p>
        </div>
      </div>
      <div className=" flex justify-center items-center pl-4 pr-2">
        <div className="flex flex-col text-left mt-14 mb-14 text-sm lg:text-lg overflow-auto max-w-3xl">
          <p className=" flex text-secondary text-center text-2xl md:text-3xl lg:text-3xl font-bold mb-5">
            Ce este Logopedia și cum poate ajuta un logoped copii
          </p>
          <p className=" flex text-secondary text-xl md:text-2xl lg:text-2xl font-bold mt-10 mb-5">
            Ce este Logopedia?
          </p>

          <p>
            Logopedia este o ramură a terapiei ocupaționale care se concentrează
            pe tratarea tulburărilor de comunicare, inclusiv a tulburărilor de
            vorbire, de limbaj și de înghițire. Un logoped este un terapeut
            specializat în această domeniu și lucrează cu copii și adulți care
            suferă de o varietate de probleme de comunicare.
          </p>
          <p className="mt-4">
            Logopedia poate fi utilă în cazul copiilor care întâmpină
            dificultăți în dezvoltarea abilităților de comunicare și în
            înțelegerea limbajului. Aceste dificultăți pot fi cauzate de diverse
            afecțiuni, cum ar fi tulburările de dezvoltare, autismul, sindromul
            Down sau problemele de auz. Logopedia poate ajuta copiii să își
            îmbunătățească abilitățile de comunicare și să își dezvolte
            vocabularul, astfel încât să poată comunica mai bine cu ceilalți și
            să se integreze mai ușor în societate.
          </p>
          <p className="mt-4">
            Pe lângă tratarea copiilor, logopedia poate fi benefică și pentru
            adulții care întâmpină dificultăți de comunicare, cum ar fi
            persoanele care au suferit un accident vascular cerebral sau care au
            afecțiuni neurologice. Terapia logopedică poate ajuta aceste
            persoane să își recâștige abilitățile de comunicare și să se
            adapteze la schimbările din viața lor.
          </p>
          <p className="mt-4">
            Logopedia implică de obicei o serie de tehnici și exerciții, precum
            și terapie individuală sau de grup. În timpul terapiei, logopedul va
            lucra cu pacientul pentru a identifica problemele de comunicare și
            pentru a dezvolta strategii de îmbunătățire a acestora. În plus,
            logopedul poate lucra și cu familia sau cu alte persoane care au o
            relație strânsă cu pacientul pentru a le ajuta să îl sprijine în
            dezvoltarea abilităților de comunicare.
          </p>
          <p className="mt-4">
            Astfel logopedia poate fi de mare ajutor pentru persoanele care
            suferă de tulburări de comunicare, ajutându-le să își îmbunătățească
            abilitățile de comunicare și să se integreze mai bine în societate.
            Un logoped specializat poate identifica problemele de comunicare și
            poate dezvolta un plan individualizat pentru fiecare pacient în
            parte, care să îi ajute să își atingă obiectivele de comunicare și
            să își îmbunătățească calitatea vieții.
          </p>
          <p className="mt-4">
            Tulburările de vorbire pot afecta toți oamenii, indiferent de
            vârstă, dar copiii sunt de obicei cel mai afectați.
          </p>
          <p className="mt-6 font-bold text-xl mb-4">
            Tipurile de tulburări de comunicare la copii includ:
          </p>
          <li>
            Tulburare mixtă de limbaj receptiv-expresiv, care se manifestă prin
            întârzieri ale dezvoltării vorbirii și dificultăți în a înțelegere
            limba;
          </li>
          <li>
            Tulburarea de limbaj expresiv, caracterizată de întârzieri ale
            dezvoltării vorbirii și probleme legate de aceasta;
          </li>
          <li>
            Tulburări de sunet și vorbire, care fac ca unele cuvinte să fie greu
            de exprimat.
          </li>
          <li>
            Tulburare de fluență, cunoscută și sub numele de bâlbâială: care
            poate începe din copilărie și poate dura toată viața;
          </li>
          <li>
            Tulburarea de comunicare socialăcare se referă la problemele
            copilului cu comunicarea verbală și non-verbală, care nu sunt
            cauzate de probleme de gândire.
          </li>

          <p className="mt-6 mb-4 font-bold text-xl">
            Tulburările de limbaj la copii includ următoarele:
          </p>
          <li>Bâlbâiala;</li>
          <li>
            Tulburări articulare: înlocuirea, omiterea sau adăugarea sunetelor
            în cuvinte; copilul poate fi „sâsâit” sau „rârâit”.
          </li>
          <li>
            Vorbitul prea repede: afectează fluența vorbitului și poate duce la
            dezorganizare sau deviere de la subiect.
          </li>
          <li>
            Apraxia: tulburare de vorbire oral-motorie care afectează mișcarea
            mușchilor și structurilor necesare pentru formarea sunetelor de
            vorbire în cuvinte.
          </li>
          <p className=" flex text-secondary text-xl md:text-2xl lg:text-2xl font-bold mt-10 mb-6">
            Cum poate ajuta un logoped copii?
          </p>
          <p>
            Logopedul își dă seama încă de la prima ședință de terapie, care
            sunt problemele de vorbire, urmând ca mai apoi să aleagă cel mai bun
            tratament în acest sens.
          </p>
          <p className="pt-4">
            Logopedul poate trata o varietate de tulburări de comunicare la
            copii, inclusiv probleme de articulare, fluență și rezonanță sau
            probleme de voce. De asemenea, poate trata probleme de hrănire orală
            și probleme de receptare a limbii, exprimare și utilizare pragmatică
            a limbajului. Logopedia are ca scop îmbunătățirea abilităților de
            comunicare și dezvoltarea unui mod adecvat de a folosi limbajul.
          </p>

          <p className="mt-6 mb-4">
            Logopedul foloseste strategii adaptate pentru fiecare afecțiune în
            parte. Printre aceastea pot fi incluse:
          </p>
          <li>
            activități de intervenție lingvistică, care construiesc abilități
            într-o varietate de moduri, inclusiv modelarea și oferirea
            feedback-ului copiilor. Logopedul poate folosi imagini și cărți sau
            terapie bazată pe joc.
          </li>
          <li>
            terapia articulară, prin care se modelează sunetele cu care copilul
            are probleme. Aceasta pot include demonstrarea modului în care
            trebuie mutată limba pentru a putea creea sunete specifice.
          </li>
          <li>
            tratamentul de hrănire și înghițire, prin care se invata copilul
            exerciții prin care își poate întări mușchii gurii. Aici poate fi
            inclus masaj facial, dar și diferite exerciții de limbă, buze și
            maxilar. Logopedul ar putea, de asemenea, să utilizeze diferite
            texturi alimentare pentru a încuraja conștientizarea în timpul mesei
            și înghițirii.
          </li>

          <p className="pt-4">
            Pentru diagnosticarea dificultăților de vorbire și limbaj, logopedul
            îi testează abilitățile de gândire ale copilului, face teste pentru
            a verifica abilitățile de raționament, reacțiile la diferite
            situații și gândirea.
          </p>
          <p className="mt-4">
            Durata terapiei poate varia in functie de vârsta copilului, tipul și
            severitatea tulburării de vorbire, frecvența cu care au loc
            ședințele de logopedie, dar și existența și tratamentul unei
            afecțiuni medicale deja existente.
          </p>

          <p className="mt-4">
            Este dovedit că logopedia are cel mai mare succes atunci când începe
            încă din stadii incipiente. Logopedia poate îmbunătăți comunicarea
            și poate stimula încrederea în sine, extrem de importante pentru
            dezvoltarea armonioasă a unui copil.
          </p>
          <p className="mt-4">
            Implicarea părintelui joacă un rol foarte important pentru succesul
            ședințelor de logopedie. Specialistul poate recomanda activități
            care trebuie făcute acasă, pentru a veni în sprijinul ședințelor de
            logopedie. Copii ai căror părinți s-au implicat în terapie au avut
            cele mai bune rezultate. De asemenea, este indicat ca toți membrii
            familiei să dea dovadă de înțelegere cu copilul.
          </p>

          <p className="mt-4">
            În cazul în care copilul dumnevoastră prezintă probleme de vorbire
            de orice fel nu ezitați să apelați la un logoped.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Blog;
